import React from 'react';
import { offer } from '../data/offer';
const links = [offer.supportEmail, offer.socialNetwork, 'Mentions légales', 'Conditions générales de vente', 'Politique de confidentialité'];
export function Footer() {
  return <footer className="w-full border-t border-warm-line bg-creme-dark" data-id="element-104" data-mp="32pfeg99kbdx4">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 md:px-10" data-id="element-105" data-mp="36ooajks2rnvu">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12" data-id="element-106" data-mp="3uf0n58y9m8sr">
          <div className="lg:col-span-5" data-id="element-107" data-mp="3uftlblj5rpza">
            <p className="font-serif text-lg font-semibold text-graphite" data-id="element-108" data-mp="38h81hlebwon">
              {offer.name} — {offer.method}
            </p>
            <p className="mt-3 max-w-prose text-sm leading-relaxed text-warm" data-id="element-109" data-mp="3ldkep6r0ggr6">
              Pour les coachs qui préfèrent un cadre solide aux promesses
              spectaculaires.
            </p>
          </div>

          <nav aria-label="Liens légaux et contact" className="lg:col-span-7" data-id="element-110" data-mp="29xvps9u757nq">
            <ul className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-graphite-mid" data-id="element-111" data-mp="2ez1l8ff8r90y">
              {links.map(link => <li key={link} data-id="element-112" data-mp="3l9sgay2igglb">
                  <a href="#offre" className="underline decoration-warm-line underline-offset-4 transition-colors duration-150 ease-out hover:text-graphite" data-id="element-113" data-mp="3gapb9dmj6adc">
                    {link}
                  </a>
                </li>)}
              <li className="text-warm" data-id="element-114" data-mp="82qt3uy8hxus">
                Médiateur de la consommation : {offer.mediator}
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-14 border-t border-warm-line pt-8" data-id="element-115" data-mp="31uotg9z09ou">
          <p className="max-w-3xl text-xs leading-relaxed text-warm" data-id="element-116" data-mp="hriflnkizpyb">
            Contenu à visée éducative et informative destiné à des coachs
            formés. Il ne remplace pas un avis médical, psychiatrique ou
            psychologique. Le coaching n’est pas une thérapie. Aucun résultat
            n’est garanti. Licence d’usage individuel.
          </p>
          <p className="mt-6 text-xs text-warm-light" data-id="element-117" data-mp="tvd0bu5d69g7">
            © 2026 {offer.name}. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>;
}